import React from "react";
import { Container } from "react-bootstrap";
import ButtonComponent from "../UI/ButtonComponent/ButtonComponent";
const OdaberiStatusRjesenja = ({
  statuses,
  handleRadioButton,
  selectedStatus,
  submitUploadedDocument,
}) => {
  return (
    <div className="mb-3 row justify-content-center">
      <Container
        style={{
          backgroundColor: "#fafafa",
          padding: "40px",
          width: "40%",
        }}
      >
        <label>
          Odaberi status
          <>
            <ul style={{ listStyleType: "none", paddingLeft: "20px" }}>
              {statuses.map((element) => (
                <div key={`status-rjesenja${element.id}`}>
                  <li>
                    <input
                      key={element.id}
                      onChange={handleRadioButton}
                      name="radio button"
                      type="radio"
                      value={element.value}
                      id={element.id}
                    />{" "}
                    {element.value}
                  </li>
                </div>
              ))}
            </ul>
          </>
        </label>
      </Container>
    </div>
  );
};

export default OdaberiStatusRjesenja;
